// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ew_lomake_start_wrapper p[data-v-7806d9b0]{text-align:center;font-family:exoregular}#ew_lomake_start_wrapper h1[data-v-7806d9b0]{font-family:exobold;font-weight:400;font-size:25px;text-align:center}.ew_room_img[data-v-7806d9b0]{border:2px solid #fff;cursor:pointer;background:#fff;width:100%}.ew_room_img[data-v-7806d9b0]:hover{border:2px solid #00aeef}", ""]);
// Exports
module.exports = exports;
